/** @format */
import qs from 'qs';

import { ModelSearchResultsType } from '../constants';
import {
    ModelSearchResultsSearchParams,
    Query,
    SelectedFilters,
} from '../types';
import { getSortedFilterQueryString } from './helpers';

export function getModelSearchResultsQueryKey(
    baseQuery: Partial<Query>,
    searchParams: ModelSearchResultsSearchParams
) {
    return qs.stringify(
        { baseQuery, ...searchParams },
        { arrayFormat: 'comma' }
    );
}

export function getModelFacetsQueryKey(
    type: ModelSearchResultsType,
    baseQuery: Partial<Query>,
    selectedFilters: SelectedFilters
) {
    const sortedFilterQueryString = getSortedFilterQueryString(selectedFilters);

    const queryKey = [
        'facets',
        type,
        qs.stringify(baseQuery, { arrayFormat: 'comma' }),
        sortedFilterQueryString,
    ];

    return queryKey;
}
